<button
  [type]="type"
  class="button button--{{color}}"
  [ngClass]="{
  'button--block': block
  }" mat-ripple
  [disabled]="disabled">
  <ng-content></ng-content>
</button>
